//接口文档http://43.138.218.52:8090/swagger-ui.html#/


//  https://hzshixiang.site/aromaAdmin/index.html#/Login



// token=>202过期默认账号密码admin 123456
// Csj12321品牌

const PROD_SITE = 'https://hzshixiang.site/'
const PROD_PC = 'https://hzshixiang.site/pc/'

function withTrailingSlash (base) {
  if (!base) return ''
  const s = String(base).trim()
  return s.endsWith('/') ? s : s + '/'
}

// npm run local 时由 config/local.env.js 注入；否则走线上默认
const urls = withTrailingSlash(process.env.API_SITE_ORIGIN) || PROD_SITE

const mubanId = 12192

const https = withTrailingSlash(process.env.API_PC_BASE) || PROD_PC

const api = {

	uploadImg: "https://hzshixiang.site/pc/"+ "file/upload",//图片上传

	uploadImgV2: https + "file/uploadV2",//图片上传V2

	Login: https + "manager/login",//登录



	// 文件上传
	uploadFile: https + "file/uploa",//上传


	// 账号
	addAccount: https + "manager/add",//新增
	delAccount: https + "manager/delete",//删除
	selAccount: https + "manager/getList",//查询
	upAccount: https + "manager/update",//更新


	// 品牌管理
	addBrand: https + "brand/add",//新增
	delBrand: https + "brand/delete",//删除
	selBrand: https + "brand/getList",//查询
	upBrand: https + "brand/update",//更新


	// 品牌型号
	addModel: https + "type/add",//新增
	delModel: https + "type/delete",//删除
	selModel: https + "mgmt/type/getList",//查询（管理端，返回全部）
	upModel: https + "type/update",//更新
	uploadBrandTypeInfo: https + "type/uploadBrandTypeInfo",//上传品牌型号信息
	exportTypeErrorExcel: https + "type/exportTypeErrorExcel",//导出错误类型Excel
	downloadTemplate: https + "type/downloadTemplate",//下载模板
	batchUploadTypeSpectrogram: https + "type/batchUploadTypeSpectrogram",//批量上传品牌谱数据
	batchUploadTypeImage: https + "type/batchUploadTypeImage",//批量上传品牌型号图片
	exportUploadFileErrorExcel: https + "type/exportUploadFileErrorExcel",//导出上传文件错误Excel


	//用户管理
	addUser: https + "user/add",//新增
	delUser: https + "user/delete",//删除
	selUser: https + "user/getList",//查询
	upUser: https + "user/update",//更新

	// 官方寄售官方帐号 xw_secondhand_official_account（后台）
	selOfficialUserMgmtList: https + "mgmt/secondhand/official/list",
	upsertOfficialUserMgmt: https + "mgmt/secondhand/official/upsert",
	deleteOfficialUserMgmt: https + "mgmt/secondhand/official/delete",

	//基本设置
	addSet: https + "set/add",//新增
	delSet: https + "set/delete",//删除
	selSet: https + "set/getList",//查询
	upSet: https + "set/update",//更新



	//反馈意见
	addFeedback: https + "opinion/add",//新增
	delFeedback: https + "opinion/delete",//删除
	selFeedback: https + "mgmt/opinion/getList",//查询（后台批量优化）
	upFeedback: https + "opinion/update",//更新
	selOpinionMessageList: https + "opinion/message/getList",//会话消息（管理端不传 userId）
	addOpinionMessage: https + "opinion/message/add",//发送消息（平台 senderType=2）



	//常见问题
	addQuestion: https + "question/add",//新增
	delQuestion: https + "question/delete",//删除
	selQuestion: https + "question/getList",//查询
	upQuestion: https + "question/update",//更新
	sortQuestion: https + "question/sort",//问题排序

	//问题分类
	addQuestionCategory: https + "question/category/add",//新增分类
	upQuestionCategory: https + "question/category/update",//更新分类
	delQuestionCategory: https + "question/category/delete",//删除分类
	getQuestionCategoryTree: https + "question/category/tree",//树形列表
	getQuestionCategoryList: https + "question/category/list",//分页列表
	sortQuestionCategory: https + "question/category/sort",//分类排序

	//轮播图
	addBanner: https + "slideshow/add",//新增
	delBanner: https + "slideshow/delete",//删除
	selBanner: https + "slideshow/getList",//查询
	upBanner: https + "slideshow/update",//更新



	//物流公司
	addLogistics: https + "company/add",//新增
	delLogistics: https + "company/delete",//删除
	selLogistics: https + "company/getList",//查询
	upLogistics: https + "company/update",//更新




	// 轮播图
	addBanner: https + "slideshow/add",//新增
	delBanner: https + "slideshow/delete",//删除
	selBanner: https + "slideshow/getList",//查询
	upBanner: https + "slideshow/update",//更新

	// 设置相关
	addSet: https + "set/add",//新增
	delSet: https + "set/delete",//删除
	selSet: https + "set/getList",//查询
	upSet: https + "set/update",//更新

	// 类别
	addType: https + "type/add",//新增
	delType: https + "type/delete",//删除
	selType: https + "mgmt/type/getList",//查询（管理端，返回全部）
	upType: https + "type/update",//更新



	// 订单
	addOrder: https + "order/add",//新增
	delOrder: https + "order/delete",//删除
	selOrder: https + "order/getList",//查询
	upOrder: https + "order/update",//更新
	startIdentify: https + "order/startIdentify",//开始鉴别
	refundOrder: https + "payReturn/return",//退款（历史，固定关单）
	xwOrderAdminRefund: https + "xwOrder/adminRefund",//管理端退款（仅退款/关单退款）
	xwOrderAdminClose: https + "xwOrder/adminClose",//管理端关单（不退款）
	xwOrderRefundRecordList: https + "xwOrder/refundRecord/getList",//鉴别/寄售退款流水
	refundFatherpayOrder: https + "fatherpayReturn//return",//父级退款

	addReservation: https + "sf/addOrder2",//预约

	// 导出
	excelOrder: https + "excel/addOrderExcel",//导出

	jsOrderExcel: https + "excel/jsOrderExcel",//导出


	//用户
	addUser: https + "user/add",//新增
	delUser: https + "user/delete",//删除
	selUser: https + "user/getList",//查询
	upUser: https + "user/update",//更新



	//金额设置
	addCharge: https + "charge/add",//新增
	delCharge: https + "charge/delete",//删除
	selCharge: https + "charge/getList",//查询
	upCharge: https + "charge/update",//更新


	// 鉴别编号
	identifyCode:https + "jbdh/getJbdh",//查询

	// 短信通知
	sendReportNotify: https + "order/sendReportNotify",//发送报告通知短信

	// 批号查询管理
	selBatchCalLogic: https + "batchCalLogic/page",//品牌逻辑列表查询
	saveBrandBatchCalLogic: https + "brandBatchCalLogic/save",//关联品牌
	updateBatchCalLogic: https + "batchCalLogic/update",//更新品牌逻辑
	getBrandsByCode: https + "batchCalLogic/getBrandsByCode/",//根据逻辑编码查询关联品牌
	getLogicsByBrandId: https + "batchCalLogic/getLogicsByBrandId/",//根据品牌ID查询关联逻辑
	removeBrandBatchCalLogic: https + "brandBatchCalLogic/remove/",//删除关联品牌
	selUserContributionBatch: https + "userContributionBatch/page",//用户贡献批号列表查询
	updateUserContributionBatch: https + "userContributionBatch/update",//更新贡献批号
	removeUserContributionBatch: https + "userContributionBatch/remove/",//删除贡献批号
	selUserNoBrandBatchCalLogic: https + "userNoBrandBatchCalLogic/page",//无品牌逻辑查询记录

	// 规格/品牌规格配置
	specOptionPage: https + "mgmt/specOption/page",
	specOptionSave: https + "mgmt/specOption/save",
	specOptionUpdate: https + "mgmt/specOption/update",
	specOptionRemove: https + "mgmt/specOption/remove/",
	brandSpecListJson: https + "mgmt/brandSpec/listJson",
	brandSpecSave: https + "mgmt/brandSpec/save",
	brandSpecSaveBatch: https + "mgmt/brandSpec/saveBatch",
	brandSpecAddBatch: https + "mgmt/brandSpec/addBatch",
	brandSpecRemoveBatch: https + "mgmt/brandSpec/removeBatch",
	brandSpecEnabledOptions: https + "mgmt/brandSpec/enabledOptions/",
	downloadBrandSpecImportTemplate: https + "mgmt/brandSpec/downloadImportTemplate",
	uploadBrandSpecImport: https + "mgmt/brandSpec/uploadImport",
	exportBrandSpecImportErrorExcel: https + "mgmt/brandSpec/exportImportErrorExcel",
	migrateBrandSpecFromTypeCapacity: https + "mgmt/brandSpec/migrateFromTypeCapacity",
	replaceBrandSpecFromTypeCapacity: https + "mgmt/brandSpec/replaceFromTypeCapacity",
	specOptionList: https + "mgmt/specOption/list",

	// 型号搜索无结果（用户搜不到的关键词记录）
	selTypeSearchMiss: https + "typeSearchMiss/getList",//分页查询
	upTypeSearchMissStatus: https + "typeSearchMiss/updateStatus",//更新状态/备注

	// 二手商品后台管理 MgmtSecondhandProductController：/pc/mgmt/secondhand/product
	selSecondhandProduct: https + "mgmt/secondhand/product/getList",//分页列表 POST
	getSecondhandProductById: https + "mgmt/secondhand/product/getById",//详情 GET ?id=
	exportSecondhandProduct: https + "mgmt/secondhand/product/exportList",//导出商品 POST
	auditSecondhandApprove: https + "mgmt/secondhand/product/audit/approve",//人工审核通过 POST
	auditSecondhandReject: https + "mgmt/secondhand/product/audit/reject",//人工审核驳回 POST
	addSecondhandProduct: https + "mgmt/secondhand/product/add",//发布 POST
	updateSecondhandProduct: https + "mgmt/secondhand/product/update",//更新 POST
	updateConsignorSecondhandPrice: https + "mgmt/secondhand/product/consignor/updatePrice",//官方寄售-货主改价 POST
	deleteSecondhandProduct: https + "mgmt/secondhand/product/delete",//删除 GET ?id=
	offlineSecondhandProduct: https + "mgmt/secondhand/product/offline",//下架 GET ?id=
	startSecondhandAuction: https + "mgmt/secondhand/product/startAuction",//设为拍卖中 GET ?id=
	endSecondhandAuction: https + "mgmt/secondhand/product/endAuction",//结束拍卖并上架 GET ?id=
	syncSecondhandProductEs: https + "mgmt/secondhand/product/syncEs",//同步商品到ES POST
	syncSecondhandProductEsBatch: https + "mgmt/secondhand/product/syncEsBatch",//批量同步商品到ES POST {ids:[]}

	// 官方寄售闲置 ↔ 寄售子单关联
	downloadConsignOrderLinkTemplate: https + "mgmt/secondhand/product/consignOrderLink/downloadImportTemplate",
	uploadConsignOrderLinkImport: https + "mgmt/secondhand/product/consignOrderLink/uploadImport",
	linkConsignOrder: https + "mgmt/secondhand/product/consignOrderLink/link",
	searchConsignOrdersForLink: https + "mgmt/secondhand/product/consignOrderLink/searchOrders",

	/** 官方寄售：平台官方帐号 userId（代发闲置时 sellerUserId） */
	getSecondhandOfficialUserId: https + "secondhand/official/get",

	// 官方寄售成交单（未关联寄售子单，平台代发货）MgmtOfficialConsignTradeController
	officialConsignTradePendingList: https + "mgmt/officialConsign/trade/pendingDeliveryList",
	officialConsignTradeCopyAddresses: https + "mgmt/officialConsign/trade/copyAllAddresses",
	officialConsignTradeConfirmReceive: https + "mgmt/officialConsign/trade/confirmReceive",

	// 系统变量 MgmtSysSettingController：/pc/mgmt/sysSetting
	selSysSetting: https + "mgmt/sysSetting/page",
	addSysSetting: https + "mgmt/sysSetting/add",
	upSysSetting: https + "mgmt/sysSetting/update",

	// 敏感词库 MgmtSensitiveWordController：/pc/mgmt/sensitiveWord
	selSensitiveWord: https + "mgmt/sensitiveWord/page",
	addSensitiveWord: https + "mgmt/sensitiveWord/add",
	upSensitiveWord: https + "mgmt/sensitiveWord/update",
	delSensitiveWord: https + "mgmt/sensitiveWord/delete",

	// 字典管理（xw_sys_dict_type / xw_sys_dict_data）MgmtSysDictController：/pc/mgmt/dict
	selMgmtDictTypeList: https + "mgmt/dict/type/list",
	upMgmtDictType: https + "mgmt/dict/type/update",
	delMgmtDictType: https + "mgmt/dict/type/delete",
	selMgmtDictTypes: https + "mgmt/dict/types",
	selMgmtDictDataList: https + "mgmt/dict/data/list",
	addMgmtDictData: https + "mgmt/dict/data/add",
	upMgmtDictDataValue: https + "mgmt/dict/data/updateValue",

	// 首页二手轮播 MgmtHomeSecondhandBannerController：/pc/mgmt/homeSecondhandBanner
	selHomeSecondhandBanner: https + "mgmt/homeSecondhandBanner/page",
	addHomeSecondhandBanner: https + "mgmt/homeSecondhandBanner/add",
	upHomeSecondhandBanner: https + "mgmt/homeSecondhandBanner/update",
	delHomeSecondhandBanner: https + "mgmt/homeSecondhandBanner/delete",

	// 买卖家聊天后台管理 MgmtChatController：/pc/mgmt/chat
	selMgmtChatConversation: https + "mgmt/chat/conversation/getList",//会话分页 POST
	selMgmtChatMessages: https + "mgmt/chat/messages",//聊天记录 GET ?conversationId=&page=&size=

	// 二手订单后台管理 MgmtSecondhandOrderController：/pc/mgmt/secondhand/order
	selSecondhandOrder: https + "mgmt/secondhand/order/getList",//分页列表 POST
	getSecondhandOrderById: https + "mgmt/secondhand/order/getById",//详情 GET ?id=
	selSecondhandInspectionCenterShipRemindList: https + "mgmt/secondhand/order/inspectionCenterShipRemind/list", // 买家催促验货中心发货记录 POST
	updateSecondhandOrder: https + "mgmt/secondhand/order/update",//更新 POST
	supplementSecondhandBuyerAddress: https + "mgmt/secondhand/order/supplementBuyerAddress", // 补写买家收货地址 POST
	deleteSecondhandOrder: https + "mgmt/secondhand/order/delete",//删除 POST
	huifuReverseRefundSecondhandOrder: https + "mgmt/secondhand/order/huifu/reverseRefund",//汇付延时分账未分账退款 POST
	huifuDivRefundSecondhandOrder: https + "mgmt/secondhand/order/huifu/divRefund",//汇付延时分账已分账退款 POST
	notifySellerInspectionFee: https + "mgmt/secondhand/order/notifySellerInspectionFee", // 假货待付鉴别费：站内通知卖家 POST

	mgmtPickupBookingFailList: https + "mgmt/pickup/bookingFail/list",
	mgmtPickupBookingFailDetail: https + "mgmt/pickup/bookingFail/detail",
	mgmtPickupBookingFailRetry: https + "mgmt/pickup/bookingFail/retry",
	mgmtPickupBookingFailMarkManual: https + "mgmt/pickup/bookingFail/markManual",

	// 退货寄件运费申诉 / 预约寄件订单 MgmtSecondhandPickupController：/pc/mgmt/secondhand/pickup
	mgmtPickupOrderList: https + "mgmt/secondhand/pickup/list",
	mgmtPickupOrderDetail: https + "mgmt/secondhand/pickup/detail",
	mgmtPickupCancelFreightRetry: https + "mgmt/secondhand/pickup/cancelFreight/retryRefund",
	mgmtPickupCancelAndRefund: https + "mgmt/secondhand/pickup/cancelAndRefund",
	mgmtPickupFreightAppealPending: https + "mgmt/secondhand/pickup/freightAppeal/pendingList",
	mgmtPickupFreightAppealReject: https + "mgmt/secondhand/pickup/freightAppeal/reject",
	mgmtPickupFreightAppealApprove: https + "mgmt/secondhand/pickup/freightAppeal/approveRefund",
	mgmtSellerReturnFreightUnpaid: https + "mgmt/secondhand/pickup/sellerReturnFreight/unpaidList",
	mgmtSellerReturnFreightSendNotify: https + "mgmt/secondhand/pickup/sellerReturnFreight/sendPayNotify",

	// 安心购流程（后台/鉴别中心操作）：/pc/secondhand/inspection
	submitInspectionReport: https + "secondhand/inspection/report/submit",
	updateInspectionReport: https + "secondhand/inspection/report/update",
	centerConfirmReceive: https + "secondhand/inspection/center/confirmReceive",
	centerStartInspecting: https + "secondhand/inspection/center/startInspecting",
	centerShipToBuyerAfterConfirm: https + "secondhand/inspection/center/shipToBuyer",
	sellerConfirmPayInspectionFee: https + "secondhand/inspection/seller/payInspection/confirm",
	centerShipBackToSeller: https + "secondhand/inspection/center/shipBackToSeller",
	refundForInspectionIssue: https + "secondhand/inspection/issue/refund",

	// 寄售评级与一键上架：/pc/mgmt/consignment/grade
	consignmentGradeStandard: https + "mgmt/consignment/grade/standard",
	consignmentGradeContext: https + "mgmt/consignment/grade/context",
	consignmentGradePreview: https + "mgmt/consignment/grade/preview",
	consignmentGradeSubmit: https + "mgmt/consignment/grade/submit",
	consignmentGradeDefectImages: https + "mgmt/consignment/grade/defectImages",
	consignmentGradeNextPending: https + "mgmt/consignment/grade/nextPending",
	consignmentGradePublish: https + "mgmt/consignment/grade/publish",
	consignmentGradeBatchPublish: https + "mgmt/consignment/grade/batchPublish",
	exportConsignmentBatchPublishResult: https + "mgmt/consignment/grade/batchPublish/exportSuccess",// 导出一键上架成功明细 POST

	// 小法官后台管理 MgmtShJurorProfileController：/pc/mgmt/secondhand/juror
	selSecondhandJuror: https + "mgmt/secondhand/juror/getList",//分页列表 POST
	updateSecondhandJuror: https + "mgmt/secondhand/juror/update",//状态变更 POST
	addSecondhandJuror: https + "mgmt/secondhand/juror/add",//新增 POST

	// 二手纠纷后台管理 MgmtShDisputeController：/pc/mgmt/secondhand/dispute/case
	selSecondhandDisputeCase: https + "mgmt/secondhand/dispute/case/getList",//分页列表 POST
	secondhandDisputeCaseDetail: https + "mgmt/secondhand/dispute/case/detail",//案件详情 GET ?caseId=
	secondhandDisputeVoteSnapshot: https + "mgmt/secondhand/dispute/case/voteSnapshot",//票况 GET ?caseId=
	secondhandDisputeSockPuppets: https + "mgmt/secondhand/dispute/case/sockPuppets",//马甲列表 GET
	secondhandDisputeSockPuppetsForCase: https + "mgmt/secondhand/dispute/case/sockPuppetsForCase",//按纠纷：可选/已投 GET ?caseId=
	secondhandSockPuppetPage: https + "mgmt/secondhand/dispute/case/sockPuppetPage",//马甲分页维护 POST
	secondhandSockPuppetSave: https + "mgmt/secondhand/dispute/case/sockPuppetSave",//马甲新增/更新 POST
	secondhandDisputeSockVote: https + "mgmt/secondhand/dispute/case/sockVote",//马甲投票 POST
	secondhandDisputeSockVoteBatch: https + "mgmt/secondhand/dispute/case/sockVoteBatch",//马甲批量投票 POST
	secondhandDisputePlatformSimple: https + "mgmt/secondhand/dispute/case/platform/simple",//简易裁 POST
	secondhandDisputeTransferToJury: https + "mgmt/secondhand/dispute/case/trial/transferToJury",//客服阶段→小法庭 POST ?caseId=
	secondhandDisputePlatformForceJury: https + "mgmt/secondhand/dispute/case/platform/forceJuryVerdict",//评审期强制裁定 POST
	secondhandDisputePlatformVerdictAppealReview: https + "mgmt/secondhand/dispute/case/platform/verdictAppealReview",//判定申诉复核改判 POST

	// 快递100（与小程序 logisticsBox、订单详情一致）
	kuaidiSelect: https + "kuaidi/select", // GET com num phone?
	kuaidiCloudAutoNumber: https + "kuaidi/cloud/autoNumber", // GET num 智能识别快递公司

	// 鉴别作业管理 InspectionJobController：/pc/inspection/job
	getInspectionJobList: https + "inspection/job/getList", // 分页列表 POST
	getInspectionJobById: https + "inspection/job/getById", // 详情 GET ?id=
	updateInspectionJob: https + "inspection/job/update", // 更新 POST
	bindShelf: https + "inspection/job/bindShelf", // 绑定货架 POST
	setInspectionNoPrinted: https + "inspection/job/setInspectionNoPrinted", // 设置鉴别号已打印 POST
	selWaitingDeliveryList: https + "inspection/job/waitingDeliveryList", // 待发货列表（旧，按 status=5）
	selPlatformWaitingDeliveryList: https + "inspection/job/platformWaitingDeliveryList", // 平台待发货列表 POST
	getAllDeliveryAddresses: https + "inspection/job/getAllDeliveryAddresses", // 获取所有待发货收货地址 POST
	getAllPlatformDeliveryAddresses: https + "inspection/job/getAllPlatformDeliveryAddresses", // 平台待发货地址复制 POST
	rebuildPlatformPendingDelivery: https + "inspection/job/rebuildPlatformPendingDelivery", // 回填待发货标记 POST
	batchUploadSpectrogram: https + "inspection/job/batchUploadSpectrogram", // 批量上传谱图 POST
	uploadSpectrumTxtForJob: https + "inspection/job/uploadSpectrumTxtForJob", // 作业详情上传TXT生成谱图 POST
	updateInspectionJobSamplePictures: https + "inspection/job/updateSamplePictures", // 作业详情补传实物图 POST
	exportUploadSpectrogramErrorExcel: https + "inspection/job/exportUploadSpectrogramErrorExcel", // 导出异常报告 POST
	rollbackInspectionJobStatus: https + "inspection/job/rollbackInspectionJobStatus", // 回滚状态 POST
	submitInspectionJobResult: https + "inspection/job/submitInspectionJobResult", // 提交鉴别结果 POST
	updateInspectionJobResult: https + "inspection/job/updateInspectionJobResult", // 修改已出具鉴别结果 POST
	getWaitLiquidInspectionSeq: https + "inspection/job/getWaitLiquidInspectionSeq", // 获取待鉴别液鉴别序号 POST

	// 鉴别报告（与小程序 jbReport 同源）
	getOrderReport: https + "order/report/getById", // GET ?id=
	getSecondhandOrderReport: https + "secondhand/order/report/getById", // GET ?id=
}

module.exports = {
	api: api,
	urls: urls,
	mubanId: mubanId,
}



// WEBPACK FOOTER //
// ./src/util/requestUrl.js